//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { type Class, type Ref, type Type } from '@hcengineering/core'
import { type Plugin, plugin } from '@hcengineering/platform'
import type { AnyComponent } from '@hcengineering/ui'

/**
 * @public
 * A computed, persisted numeric field. `expression` is a small arithmetic
 * formula (+ - * / and parentheses) referencing sibling attribute names on
 * the same object, e.g. "estimation * rate". To keep cycle-detection trivial,
 * v1 formulas may only reference plain (non-formula) fields — see
 * extractFormulaFieldRefs/validateFormulaSyntax in ./evaluator for the
 * expression parser shared by the editor UI and the server recompute trigger.
 */
export interface TypeFormula extends Type<number> {
  expression: string
}

/**
 * @public
 */
export const formulaId = 'formula' as Plugin

export default plugin(formulaId, {
  class: {
    TypeFormula: '' as Ref<Class<TypeFormula>>
  },
  component: {
    FormulaEditor: '' as AnyComponent,
    FormulaPresenter: '' as AnyComponent
  }
})

export * from './evaluator'
